import { shrpaApi } from "./axios";
import { AssetsDownloadRequest } from "@contracts/assetsDownloadRequest";

export default {
  async LoadByContextId(
    customerId: string,
    contextId: string,
    createIfNotFound = true,
    collabInputId?: string | null,
    uploadCampaignId?: string | null,
    uploaderEmail?: string | null,
    locationExternalId?: string | null
  ): Promise<AssetsDownloadRequest> {
    let uri = `/customer/${customerId}/assets-download-requests/${contextId}`;

    const urlSearchParams = new URLSearchParams();
    if (createIfNotFound) urlSearchParams.append("createIfNotFound", String(true));
    if (collabInputId) urlSearchParams.append("collabInputId", collabInputId);
    if (uploadCampaignId) urlSearchParams.append("uploadCampaignId", uploadCampaignId);
    if (uploaderEmail) urlSearchParams.append("uploaderEmail", uploaderEmail);
    if (locationExternalId) urlSearchParams.append("locationExternalId", locationExternalId);

    uri += "?" + urlSearchParams.toString();

    const { data } = await shrpaApi.get<AssetsDownloadRequest>(uri);

    return data;
  },
};
